import type { NotificationPreferenceResponse, NotificationType } from "@/api";

export const NOTIFICATION_EVENTS = [
  "flow_completed",
  "flow_failed",
  "flow_paused",
  "scheduled_flow_triggered",
  "chat_shared",
  "brainstorm_shared",
  "data_sync_completed",
  "data_sync_failed",
] as const satisfies readonly NotificationType[];

export type NotificationEvent = (typeof NOTIFICATION_EVENTS)[number];

export const DEFAULT_CHANNELS = { inAppEnabled: true, desktopEnabled: false } as const;

export interface NotificationRow {
  type: NotificationEvent;
  inApp: boolean;
  desktop: boolean;
}

export function toRows(preferences: NotificationPreferenceResponse[] | undefined): NotificationRow[] {
  const byType = new Map((preferences ?? []).map((p) => [p.notificationType, p]));
  return NOTIFICATION_EVENTS.map((type) => {
    const pref = byType.get(type);
    return {
      type,
      inApp: pref?.inAppEnabled ?? DEFAULT_CHANNELS.inAppEnabled,
      desktop: pref?.desktopEnabled ?? DEFAULT_CHANNELS.desktopEnabled,
    };
  });
}
